import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import get from 'lodash.get';
import {
    FETCH_FORM_DATA,
    FETCH_FORM_IDS_FOR_MULTIPLE_GRADES,
} from '../../actionTypes/shared/apiActionTypes';
import { PERIOD } from '../../../constants/shared/CommonConstants';
import { parseFormIdsData, getSharedParserFormByMeasure } from './formsReducerParsers';

const { BOY, MOY, EOY } = PERIOD;

export const initialState = {
    data: [],
    formIdsDataByPeriod: { [BOY]: [], [MOY]: [], [EOY]: [] },
    isFormFetching: false,
    isFormIdsDataFetching: false,
    error: null,
};

export const reducer = (
    state = initialState,
    action = {},
    getFormCallback = getSharedParserFormByMeasure,
) => {
    switch (action.type) {
        case FETCH_FORM_DATA.START:
            return {
                ...state,
                isFormFetching: true,
            };
        case FETCH_FORM_DATA.SUCCESS: {
            const { data } = state;
            const { response, additionalResponseParams } = action;
            const newData = !data.includes(additionalResponseParams.formUid)
                ? [...data, getFormCallback(response)]
                : data;
            return {
                ...state,
                data: newData,
                isFormFetching: false,
            };
        }
        case FETCH_FORM_DATA.ERROR:
            return {
                ...state,
                error: action.error,
                isFormFetching: false,
            };
        case FETCH_FORM_IDS_FOR_MULTIPLE_GRADES.START:
            return {
                ...state,
                isFormIdsDataFetching: true,
            };
        case FETCH_FORM_IDS_FOR_MULTIPLE_GRADES.SUCCESS:
            return {
                ...state,
                formIdsDataByPeriod: {
                    ...state.formIdsDataByPeriod,
                    [action.additionalResponseParams.period]: parseFormIdsData(action.response),
                },
                isFormIdsDataFetching: false,
            };
        case FETCH_FORM_IDS_FOR_MULTIPLE_GRADES.ERROR:
            return {
                ...state,
                error: action.error,
                isFormIdsDataFetching: false,
            };
        default:
            return state;
    }
};

const getForms = state => state.data;

const isFormFetching = state => state.isFormFetching;

const isFormDataExists = state => !isEmpty(state.data);

const getFormIds = state => get(state, 'formIdsDataByPeriod', {});

const getFormByID = (state, id) => getForms(state).find(item => isEqual(item.uid, id));

const getFormIdsByPeriod = (state, period) => get(getFormIds(state), period, []);

export const selectors = {
    getForms,
    getFormIds,
    getFormByID,
    isFormFetching,
    isFormDataExists,
    getFormIdsByPeriod,
};
